import axios from "axios";
import React, { useEffect, useState } from "react";

const CKEditorHtmlComponent = () => {
  const [data, setData] = useState({
    title: "",
    url: "",
    introduction: "<p>Start editing introduction...</p>",
    content: "<p>Start editing content...</p>",
    metaDiscription: "",
    metaTitle: "",
    metaKeywords: "",
    blogId: "",
  });

  useEffect(() => {
    if (window.CKEDITOR) {
      // Initialize first CKEditor instance
      const introEditor = window.CKEDITOR.replace("editor", {
        allowedContent: true,
        extraPlugins: "divarea,justify,font",
        toolbar: [
          { name: "document", items: ["Source"] },
          { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList"] },
          { name: "insert", items: ["Image", "Table", "Link", "Unlink"] }, // Added "Link" & "Unlink"
          { name: "styles", items: ["Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
        ],
      });

      // Set initial data
      introEditor.setData(data.introduction);

      introEditor.on("change", function () {
        setData((prev) => ({
          ...prev,
          introduction: introEditor.getData(),
        }));
      });

      // Initialize second CKEditor instance
      const contentEditor = window.CKEDITOR.replace("editor1", {
        allowedContent: true,
        extraPlugins: "divarea,justify,font",
        toolbar: [
          { name: "document", items: ["Source"] },
          { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList"] },
          { name: "insert", items: ["Image", "Table", "Link", "Unlink"] }, // Added "Link" & "Unlink"
          { name: "styles", items: ["Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
        ],
      });

      // Set initial data
      contentEditor.setData(data.content);

      contentEditor.on("change", function () {
        setData((prev) => ({
          ...prev,
          content: contentEditor.getData(),
        }));
      });
    }
  }, []);

  const onSubmitHandler = async (event) => {
    event.preventDefault(); // Prevent form submission

    try {
      alert(`Introduction: ${data.introduction}\nContent: ${data.content}`);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/user/testing`,
        {data} // Send data as an object
      );

      console.log("Server Response:", response.data); // Log server response
    } catch (error) {
      console.error("Error sending data:", error); // Handle errors properly
    }
  };

  return (
    <div>
      <h2>CKEditor 4 HTML Editor</h2>
      <label>Introduction:</label>
      <textarea id="editor"></textarea>
      <h3>HTML Preview:</h3>
      <div dangerouslySetInnerHTML={{ __html: data.introduction }} />

      <label>Content:</label>
      <textarea id="editor1"></textarea>
      <h3>HTML Preview:</h3>
      <div dangerouslySetInnerHTML={{ __html: data.content }} />

      <button className="btn btn-outline-primary my-2" onClick={onSubmitHandler}>
        <i className="fa fa-list mx-1"></i>
        List Blog
      </button>
    </div>
  );
};

export default CKEditorHtmlComponent;
